<template>
  <div v-if="goods.length" v-loading="loading" class="activity-products width_center_1200">
    <el-image v-if="banner" :src="banner.advImg" alt class="banner" lazy></el-image>
    <div class="goods-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in tabs"
          :key="index"
          :label="item.hdname"
          :name="item.hdno"
        ></el-tab-pane>
      </el-tabs>
      <ul class="goods-list">
        <li v-for="(item, index) in goods" :key="index">
          <goods :item="item"></goods>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getadvList } from '@/api/home'
import { mapGetters } from 'vuex'
import { getactivitydatil, getactivityproduct } from '@/api/product'
import goods from '@/components/ShopGoods/index'
export default {
  components: { goods },
  computed: {
    ...mapGetters(['unit'])
  },
  data() {
    return {
      goods: [],
      tabs: [],
      banner: {},
      activeName: '',
      loading: false
    }
  },
  methods: {
    getInfo() {
      getactivitydatil().then(({ data }) => {
        this.activeName = data.length ? data[0].hdno : null
        this.tabs = data
        this.getList()
      })
      getadvList({
        platform: 3,
        advPosition: 3
      }).then(({ data }) => {
        this.banner = data[0]
      })
    },
    getList() {
      this.loading = true
      getactivityproduct({
        hdno: this.activeName,
        keyword: ''
      }).then((res) => {
        this.loading = false
        this.goods = res.data.map((item) => {
          return {
            title: item.productname,
            ...item
          }
        })
      })
    },
    handleClick(e) {
      this.activeName = e.name
      this.getList()
    }
  },
  async created() {
    this.getInfo()
  }
}
</script>
<style lang="scss" scoped>
.activity-products {
  display: flex;
  margin-bottom: 30px;
  .banner {
    min-width: 254px;
    width: 254px;
    height: 322px;
    border-radius: 4px;
    margin-right: 10px;
    /deep/ img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-box {
    flex: 1;
    background: #fff;
    border-radius: 4px;
  }
  .goods-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 12px;
    li {
      margin: 0 8px;
      box-sizing: border-box;
      margin-bottom: 16px;
      width: 288px;
      height: 110px;
    }
  }
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__header {
  margin: 18px 20px 20px;
}
/deep/ .el-tabs__item {
  line-height: 24px;
  height: 30px;
  color: #000000;
  font-size: 18px;
}
/deep/ .el-tabs__active-bar {
  background-color: #ed9121;
}
/deep/ .el-tabs__item.is-active {
  color: #ed9121;
}
</style>